/* =============================================================================
   MM — Vos données
   Page de transparence RGPD.

   Trois garanties tenues par ce fichier :

   1. Aucune valeur n'est lue avant le consentement. Les fonctions de collecte
      ne sont appelées qu'après la réponse au bandeau Axeptio — ce n'est pas un
      masquage CSS.
   2. Aucune requête réseau. Pas de géolocalisation par IP, pas d'appel tiers,
      rien ne quitte le navigateur.
   3. Aucune valeur de cookie n'est affichée, seulement les noms : une valeur
      peut contenir un identifiant de session.

   Le consentement est lu via window.Shopify.customerPrivacy, alimenté par
   l'extension Axeptio, et rafraîchi par l'événement consent:saved du SDK.
   ============================================================================= */

(function () {
  'use strict';

  var root = document.querySelector('[data-mm-vd]');
  if (!root) return;

  var gate      = root.querySelector('[data-mm-vd-gate]');
  var gateNote  = root.querySelector('[data-mm-vd-gate-note]');
  var openBtn   = root.querySelector('[data-mm-vd-open]');
  var panel     = root.querySelector('[data-mm-vd-panel]');
  var consentEl = root.querySelector('[data-mm-vd-consent]');
  var liveEl    = root.querySelector('[data-mm-vd-live]');
  var groupsEl  = root.querySelector('[data-mm-vd-groups]');

  var started = false;

  /* ---------------------------------------------------------------- Outils */

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt !== undefined && txt !== null) n.textContent = String(txt);
    return n;
  }

  // Valeur absente : on l'affiche explicitement plutôt que de laisser un vide,
  // parce qu'« indisponible » est une information en soi.
  var ABSENT = 'non communiqué par votre navigateur';

  function nombre(n) {
    return typeof n === 'number' && isFinite(n) ? n.toLocaleString('fr-FR') : null;
  }

  /* ------------------------------------------------------ État du consentement

     Shopify expose quatre catégories. L'extension Axeptio les alimente à partir
     des vendeurs shopify_preferences / shopify_analytics / shopify_marketing /
     shopify_sale_of_data. */

  var CATEGORIES = [
    { cle: 'preferences',  nom: 'Préférences' },
    { cle: 'analytics',    nom: 'Analytique' },
    { cle: 'marketing',    nom: 'Marketing' },
    { cle: 'sale_of_data', nom: 'Vente de données' }
  ];

  function consentement() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return null;
    try {
      return cp.currentVisitorConsent();
    } catch (e) {
      return null;
    }
  }

  function aRepondu(c) {
    if (!c) return false;
    return CATEGORIES.some(function (cat) {
      var v = c[cat.cle];
      return v === 'yes' || v === 'no' || v === true || v === false;
    });
  }

  function accorde(c, cle) {
    if (!c) return false;
    return c[cle] === 'yes' || c[cle] === true;
  }

  // Le panneau ne s'ouvre que si au moins une finalité est ACCEPTÉE.
  // Avoir répondu au bandeau ne suffit pas : un refus global doit laisser la
  // page dans son état de départ, où aucune fonction de lecture n'est appelée.
  function auMoinsUnAccord(c) {
    return CATEGORIES.some(function (cat) { return accorde(c, cat.cle); });
  }

  /* ------------------------------------------------------------ Collecteurs

     Chacun renvoie un tableau de paires [libellé, valeur]. Aucun n'est appelé
     avant le consentement. */

  function grNavigateur() {
    var n = navigator;
    var ua = n.userAgentData;
    var marques = ua && Array.isArray(ua.brands)
      ? ua.brands.filter(function (b) { return !/Not.?A.?Brand/i.test(b.brand); })
                 .map(function (b) { return b.brand + ' ' + b.version; })
      : null;

    return [
      ['Navigateur annoncé', marques && marques.length ? marques.join(', ') : null],
      ['Système', ua && ua.platform ? ua.platform : (n.platform || null)],
      ['Appareil mobile', ua && typeof ua.mobile === 'boolean' ? (ua.mobile ? 'oui' : 'non') : null],
      ['Langue principale', n.language || null],
      ['Langues acceptées', n.languages && n.languages.length ? n.languages : null],
      ['Signature complète', n.userAgent || null, 'mono']
    ];
  }

  function grMateriel() {
    var s = window.screen || {};
    var n = navigator;
    var mem = n.deviceMemory;
    return [
      ['Résolution de l’écran', s.width && s.height ? s.width + ' × ' + s.height + ' px' : null],
      ['Taille de la fenêtre', window.innerWidth + ' × ' + window.innerHeight + ' px'],
      ['Densité de pixels', window.devicePixelRatio ? window.devicePixelRatio + '×' : null],
      ['Profondeur de couleur', s.colorDepth ? s.colorDepth + ' bits' : null],
      ['Cœurs processeur', nombre(n.hardwareConcurrency)],
      ['Mémoire vive annoncée', mem ? 'au moins ' + mem + ' Go' : null],
      ['Points tactiles', nombre(n.maxTouchPoints)]
    ];
  }

  function grTemps() {
    var tz = null, dec = null;
    try {
      tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) { /* certains navigateurs verrouillent cette lecture */ }
    var m = new Date().getTimezoneOffset();
    if (isFinite(m)) {
      var h = -m / 60;
      dec = 'UTC' + (h >= 0 ? '+' : '') + h;
    }
    return [
      ['Fuseau horaire', tz],
      ['Décalage', dec],
      ['Heure sur votre machine', new Date().toLocaleTimeString('fr-FR')]
    ];
  }

  function grPreferences() {
    function mq(q) {
      return window.matchMedia && window.matchMedia(q).matches;
    }
    return [
      ['Thème système', mq('(prefers-color-scheme: dark)') ? 'sombre' : 'clair'],
      ['Animations réduites', mq('(prefers-reduced-motion: reduce)') ? 'oui, demandées' : 'non'],
      ['Contraste renforcé', mq('(prefers-contrast: more)') ? 'oui' : 'non'],
      ['Transparence réduite', mq('(prefers-reduced-transparency: reduce)') ? 'oui' : 'non'],
      ['Type de pointeur', mq('(pointer: coarse)') ? 'tactile' : (mq('(pointer: fine)') ? 'souris ou stylet' : null)]
    ];
  }

  function grStockage() {
    // Noms de cookies uniquement — jamais les valeurs.
    var noms = [];
    try {
      noms = document.cookie
        .split(';')
        .map(function (c) { return c.split('=')[0].trim(); })
        .filter(Boolean);
    } catch (e) { /* cookies inaccessibles */ }

    var nbLocal = null, nbSession = null;
    try { nbLocal = window.localStorage.length; } catch (e) {}
    try { nbSession = window.sessionStorage.length; } catch (e) {}

    return [
      ['Cookies déposés sur ce domaine', noms.length ? noms : null, 'chips'],
      ['Nombre de cookies', nombre(noms.length)],
      ['Clés en stockage local', nombre(nbLocal)],
      ['Clés en stockage de session', nombre(nbSession)]
    ];
  }

  function grProvenance() {
    var ref = document.referrer || '';
    var origine = null;
    if (ref) {
      try { origine = new URL(ref).hostname; } catch (e) { origine = ref; }
    }
    var params = [];
    try {
      new URL(window.location.href).searchParams.forEach(function (v, k) {
        if (/^utm_|^gclid$|^fbclid$|^msclkid$/i.test(k)) params.push(k);
      });
    } catch (e) {}

    return [
      ['Page précédente', origine || 'aucune — accès direct ou lien masqué'],
      ['Paramètres de campagne dans l’URL', params.length ? params : 'aucun', params.length ? 'chips' : null],
      ['Signal « ne pas me pister »', (navigator.doNotTrack === '1' || window.doNotTrack === '1') ? 'activé' : 'non activé'],
      ['Global Privacy Control', navigator.globalPrivacyControl === true ? 'activé' : 'non activé']
    ];
  }

  // Empreinte : on montre le principe, pas un identifiant exploitable.
  // Le dessin est fait puis jeté ; seul un condensé court est affiché.
  function grEmpreinte() {
    var empreinte = null;
    try {
      var c = document.createElement('canvas');
      c.width = 240; c.height = 60;
      var ctx = c.getContext('2d');
      ctx.textBaseline = 'top';
      ctx.font = '16px "Aeonik Pro", sans-serif';
      ctx.fillStyle = '#E5F77D';
      ctx.fillRect(0, 0, 240, 30);
      ctx.fillStyle = '#141414';
      ctx.fillText('Moon Moon — transparence', 4, 6);
      var data = c.toDataURL();
      var h = 5381;
      for (var i = 0; i < data.length; i++) {
        h = ((h << 5) + h + data.charCodeAt(i)) >>> 0;
      }
      empreinte = h.toString(16).padStart(8, '0');
    } catch (e) { /* canvas bloqué : c'est une bonne nouvelle pour vous */ }

    var moteur = null;
    try {
      var gl = document.createElement('canvas').getContext('webgl');
      var dbg = gl && gl.getExtension('WEBGL_debug_renderer_info');
      if (gl && dbg) moteur = gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL);
    } catch (e) {}

    return [
      ['Empreinte de rendu graphique', empreinte, 'mono'],
      ['Carte graphique annoncée', moteur],
      ['Nombre de plugins déclarés', nombre(navigator.plugins ? navigator.plugins.length : null)]
    ];
  }

  /* ------------------------------------------------------------- Les groupes

     `requiert` : null = visible dès qu'une réponse a été donnée au bandeau.
     Sinon, la catégorie Shopify qui doit être accordée. */

  var GROUPES = [
    {
      titre: 'Votre navigateur',
      requiert: null,
      note: 'Ces informations sont envoyées spontanément par votre navigateur à chaque page que vous ouvrez, sur n’importe quel site. Personne n’a besoin de votre accord pour les recevoir — il en faut un pour les exploiter.',
      collecte: grNavigateur
    },
    {
      titre: 'Votre écran et votre matériel',
      requiert: null,
      note: 'Prises séparément, ces valeurs sont banales. Combinées, elles réduisent déjà beaucoup le nombre de personnes auxquelles vous pourriez correspondre.',
      collecte: grMateriel
    },
    {
      titre: 'Votre heure et votre fuseau',
      requiert: null,
      note: 'Le fuseau horaire donne une localisation approximative sans jamais demander l’accès à votre position.',
      collecte: grTemps
    },
    {
      titre: 'Vos préférences d’affichage',
      requiert: 'preferences',
      note: 'Ces réglages servent à adapter le site. Ils disent aussi des choses de vous : une demande d’animations réduites ou de contraste renforcé relève de la santé, une donnée sensible au sens du RGPD.',
      collecte: grPreferences
    },
    {
      titre: 'Ce qui est déjà stocké chez vous',
      requiert: 'preferences',
      note: 'Nous affichons les noms des cookies, jamais leurs valeurs : une valeur peut contenir un identifiant de session.',
      collecte: grStockage
    },
    {
      titre: 'D’où vous arrivez',
      requiert: 'marketing',
      note: 'La page précédente et les paramètres de campagne dans l’URL sont ce qui permet d’attribuer une visite à une publicité.',
      collecte: grProvenance
    },
    {
      titre: 'Ce qui vous rend reconnaissable',
      requiert: 'analytics',
      note: 'La façon dont votre machine dessine une image produit un résultat presque unique. C’est le principe du pistage sans cookie — celui qui survit à la navigation privée.',
      collecte: grEmpreinte
    }
  ];

  /* ------------------------------------------------------------- Affichage */

  function ligne(paire, index) {
    var l = el('div', 'mm-vd-row');
    l.style.animationDelay = Math.min(index * 45, 500) + 'ms';
    l.appendChild(el('div', 'mm-vd-row-key', paire[0]));

    var v = el('div', 'mm-vd-row-val');
    var valeur = paire[1];
    var format = paire[2];

    if (valeur === null || valeur === undefined || valeur === '') {
      v.className += ' is-empty';
      v.textContent = ABSENT;
    } else if (format === 'chips' && Array.isArray(valeur)) {
      valeur.forEach(function (t) { v.appendChild(el('span', 'mm-vd-chip', t)); });
    } else if (Array.isArray(valeur)) {
      valeur.forEach(function (t) { v.appendChild(el('span', 'mm-vd-chip', t)); });
    } else {
      if (format === 'mono') v.className += ' mm-vd-mono';
      v.textContent = valeur;
    }

    l.appendChild(v);
    return l;
  }

  function rendreGroupes(c) {
    groupsEl.textContent = '';

    GROUPES.forEach(function (g) {
      if (g.requiert && !accorde(c, g.requiert)) return;

      var paires = g.collecte().filter(function (p) { return p; });

      var bloc = el('div', 'mm-vd-group');
      var tete = el('div', 'mm-vd-group-head');
      tete.appendChild(el('h2', 'mm-vd-group-title', g.titre));
      tete.appendChild(el('span', 'mm-vd-group-count', paires.length + (paires.length > 1 ? ' informations' : ' information')));
      bloc.appendChild(tete);

      if (g.note) bloc.appendChild(el('p', 'mm-vd-group-note', g.note));

      var rows = el('div', 'mm-vd-rows');
      paires.forEach(function (p, i) { rows.appendChild(ligne(p, i)); });
      bloc.appendChild(rows);

      groupsEl.appendChild(bloc);
    });

    // Les groupes refusés sont annoncés, pas escamotés : c'est la démonstration.
    var refuses = GROUPES.filter(function (g) { return g.requiert && !accorde(c, g.requiert); });
    if (refuses.length) {
      var bloc = el('div', 'mm-vd-group');
      var tete = el('div', 'mm-vd-group-head');
      tete.appendChild(el('h2', 'mm-vd-group-title', 'Ce que nous n’avons pas lu'));
      bloc.appendChild(tete);
      bloc.appendChild(el('p', 'mm-vd-group-note',
        'Vous avez refusé une partie des finalités. Les informations correspondantes n’ont pas été lues — le code qui les collecte n’a pas été exécuté.'));
      var rows = el('div', 'mm-vd-rows');
      refuses.forEach(function (g, i) {
        var cat = CATEGORIES.filter(function (x) { return x.cle === g.requiert; })[0];
        rows.appendChild(ligne([g.titre, 'nécessite la finalité « ' + (cat ? cat.nom : g.requiert) + ' »'], i));
      });
      bloc.appendChild(rows);
      groupsEl.appendChild(bloc);
    }
  }

  function rendreConsentement(c) {
    consentEl.textContent = '';
    consentEl.appendChild(el('p', 'mm-vd-section-label mm-text-xs', 'Vos choix, tels qu’ils sont enregistrés'));

    var grille = el('div', 'mm-vd-consent-grid');
    CATEGORIES.forEach(function (cat) {
      var ok = accorde(c, cat.cle);
      var item = el('div', 'mm-vd-consent-item');
      item.setAttribute('data-granted', ok ? 'true' : 'false');
      item.appendChild(el('span', 'mm-vd-consent-state'));
      item.appendChild(el('span', 'mm-vd-consent-name', cat.nom));
      item.appendChild(el('span', 'mm-vd-consent-value', ok ? 'accepté' : 'refusé'));
      grille.appendChild(item);
    });
    consentEl.appendChild(grille);
  }

  /* --------------------------------------------------------- Bande en direct */

  var live = { debut: Date.now(), souris: 0, clics: 0, scroll: 0 };
  var liveTimer = null;
  var ecouteursPoses = false;

  /* ---------------------------------------------------------------- Faisceaux

     Chaque événement capté envoie une particule vers le compteur qui l'a
     enregistré. C'est la partie démonstrative de la page : on ne lit pas
     « 342 mouvements », on voit chaque mouvement partir vers son compteur.

     Un seul canvas plein écran, sans interception du pointeur. Le nombre de
     particules est plafonné, et tout est désactivé si le visiteur demande des
     animations réduites — cette préférence relève de la santé, on la respecte
     ici comme ailleurs. */

  var fx = (function () {
    var canvas = null, ctx = null, particules = [], raf = null;
    var PLAFOND = 260;
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var STYLES = {
      souris: { couleur: '229,247,125', taille: 2.0, duree: 620,  trainee: 5  },
      clics:  { couleur: '255,255,255', taille: 3.6, duree: 520,  trainee: 8  },
      scroll: { couleur: '169,232,180', taille: 2.4, duree: 700,  trainee: 6  },
      duree:  { couleur: '229,247,125', taille: 1.8, duree: 1100, trainee: 4  },
      minute: { couleur: '255,255,255', taille: 4.2, duree: 1300, trainee: 12 }
    };

    function init() {
      if (canvas || reduit) return;
      canvas = document.createElement('canvas');
      canvas.className = 'mm-vd-fx';
      canvas.setAttribute('aria-hidden', 'true');
      document.body.appendChild(canvas);
      ctx = canvas.getContext('2d');
      redimensionner();
      window.addEventListener('resize', redimensionner, { passive: true });
    }

    function redimensionner() {
      if (!canvas) return;
      var d = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.floor(window.innerWidth * d);
      canvas.height = Math.floor(window.innerHeight * d);
      ctx.setTransform(d, 0, 0, d, 0, 0);
    }

    // Position du compteur visé, recalculée à chaque envoi : la bande défile.
    function cible(id) {
      var n = liveEl && liveEl.querySelector('[data-live="' + id + '"]');
      if (!n) return null;
      var r = n.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }

    function envoyer(id, x, y, style) {
      if (reduit) return;
      init();
      if (!ctx) return;
      var c = cible(id);
      if (!c) return;
      if (particules.length > PLAFOND) particules.splice(0, particules.length - PLAFOND);

      var s = STYLES[style || id] || STYLES.souris;
      // Léger arc : le point de contrôle est décalé perpendiculairement au trajet.
      var mx = (x + c.x) / 2, my = (y + c.y) / 2;
      var dx = c.x - x, dy = c.y - y;
      var n = Math.sqrt(dx * dx + dy * dy) || 1;
      var amp = Math.min(n * 0.22, 90) * (Math.random() < 0.5 ? -1 : 1);

      particules.push({
        x0: x, y0: y, x1: c.x, y1: c.y,
        cx: mx + (-dy / n) * amp, cy: my + (dx / n) * amp,
        t0: performance.now(), duree: s.duree * (0.85 + Math.random() * 0.3),
        taille: s.taille * (0.8 + Math.random() * 0.5),
        couleur: s.couleur, trainee: s.trainee, id: id, arrive: false
      });

      if (!raf) raf = requestAnimationFrame(boucle);
    }

    function pos(p, t) {
      var u = 1 - t;
      return {
        x: u * u * p.x0 + 2 * u * t * p.cx + t * t * p.x1,
        y: u * u * p.y0 + 2 * u * t * p.cy + t * t * p.y1
      };
    }

    function impact(id) {
      var n = liveEl && liveEl.querySelector('[data-live="' + id + '"]');
      if (!n) return;
      n.classList.remove('is-hit');
      void n.offsetWidth; // force le redémarrage de l'animation CSS
      n.classList.add('is-hit');
    }

    function boucle(now) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var restants = [];

      for (var i = 0; i < particules.length; i++) {
        var p = particules[i];
        var t = (now - p.t0) / p.duree;

        if (t >= 1) {
          if (!p.arrive) { p.arrive = true; impact(p.id); }
          continue;
        }

        var e = 1 - Math.pow(1 - t, 3); // ease-out cubique
        var a = pos(p, e);
        var b = pos(p, Math.max(0, e - 0.06));
        var alpha = t < 0.12 ? t / 0.12 : (1 - Math.pow(t, 2.2));

        ctx.strokeStyle = 'rgba(' + p.couleur + ',' + (alpha * 0.55).toFixed(3) + ')';
        ctx.lineWidth = p.taille * 0.9;
        ctx.lineCap = 'round';
        ctx.beginPath();
        ctx.moveTo(b.x, b.y);
        ctx.lineTo(a.x, a.y);
        ctx.stroke();

        ctx.fillStyle = 'rgba(' + p.couleur + ',' + alpha.toFixed(3) + ')';
        ctx.beginPath();
        ctx.arc(a.x, a.y, p.taille, 0, Math.PI * 2);
        ctx.fill();

        restants.push(p);
      }

      particules = restants;
      raf = particules.length ? requestAnimationFrame(boucle) : null;
      if (!particules.length && ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
    }

    function detruire() {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      particules = [];
      if (canvas) {
        window.removeEventListener('resize', redimensionner);
        canvas.remove();
        canvas = null; ctx = null;
      }
    }

    return { envoyer: envoyer, detruire: detruire, reduit: reduit };
  })();

  /* Les écouteurs sont nommés pour pouvoir être retirés.

     Sans cela, ils s'empilent : `evaluer()` est appelé par cinq sources
     (l'intervalle de guet, sdk.on('ready'), sdk.on('consent:saved'),
     visitorConsentCollected, et l'appel initial). Si l'API Shopify renvoie
     momentanément null alors que le panneau est ouvert, on passe par fermer()
     puis ouvrir() — et une deuxième série d'écouteurs s'ajoute à la première.
     Chaque cycle ajoutait un incrément de plus par clic. */

  /* `mousemove` se déclenche 60 à 120 fois par seconde de déplacement. Compter
     chaque événement donne un nombre exact mais illisible — quelques secondes
     de va-et-vient et on est à plusieurs milliers. On échantillonne donc à
     100 ms : un « mouvement » correspond à un dixième de seconde pendant lequel
     la souris a bougé, ce qui correspond à l'intuition du lecteur. */
  var DERNIER = { souris: 0, scroll: 0 };
  var PAS_SOURIS = 100;
  var PAS_SCROLL = 120;

  function onMouseMove(e) {
    var t = Date.now();
    if (t - DERNIER.souris < PAS_SOURIS) return;
    DERNIER.souris = t;
    live.souris++;
    fx.envoyer('souris', e.clientX, e.clientY);
  }

  function onClick(e) {
    live.clics++;
    fx.envoyer('clics', e.clientX, e.clientY);
  }

  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? Math.round((window.scrollY / h) * 100) : 0;
    if (p > live.scroll) live.scroll = Math.min(p, 100);

    var t = Date.now();
    if (t - DERNIER.scroll < PAS_SCROLL) return;
    DERNIER.scroll = t;
    fx.envoyer('scroll', window.innerWidth - 24, window.innerHeight * 0.5);
  }

  function cellule(id, libelle) {
    var c = el('div', 'mm-vd-live-cell');
    var v = el('span', 'mm-vd-live-value', '0');
    v.setAttribute('data-live', id);
    c.appendChild(v);
    c.appendChild(el('span', 'mm-vd-live-label', libelle));
    return c;
  }

  function poserLive(id, valeur) {
    var n = liveEl.querySelector('[data-live="' + id + '"]');
    if (n) n.textContent = valeur;
  }

  function demarrerLive() {
    if (liveTimer) return; // déjà en marche : ne rien empiler

    liveEl.textContent = '';
    liveEl.appendChild(cellule('duree',  'sur cette page'));
    liveEl.appendChild(cellule('souris', 'mouvements de souris'));
    liveEl.appendChild(cellule('clics',  'clics'));
    liveEl.appendChild(cellule('scroll', 'de la page parcourue'));
    liveEl.appendChild(cellule('heure',  'heure sur votre machine'));

    if (!ecouteursPoses) {
      // Un seul écouteur par événement. `click` se déclenche aussi au toucher :
      // écouter en plus `touchstart` comptait deux fois chaque tap sur mobile.
      document.addEventListener('mousemove', onMouseMove, { passive: true });
      document.addEventListener('click', onClick, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      ecouteursPoses = true;
    }

    liveTimer = setInterval(function () {
      var s = Math.floor((Date.now() - live.debut) / 1000);
      var mm = String(Math.floor(s / 60)).padStart(2, '0');
      var ss = String(s % 60).padStart(2, '0');
      poserLive('duree',  mm + ':' + ss);
      poserLive('souris', live.souris.toLocaleString('fr-FR'));
      poserLive('clics',  live.clics.toLocaleString('fr-FR'));
      poserLive('scroll', live.scroll + ' %');
      poserLive('heure',  new Date().toLocaleTimeString('fr-FR'));

      // Chaque seconde part du bas de l'écran vers le compteur de durée.
      // Chaque minute vaut une salve, pour qu'on la remarque.
      if (s % 60 === 0 && s > 0) {
        for (var k = 0; k < 8; k++) {
          fx.envoyer('duree',
            window.innerWidth * (0.15 + Math.random() * 0.7),
            window.innerHeight + 10,
            'minute');
        }
      } else {
        fx.envoyer('duree',
          window.innerWidth * (0.3 + Math.random() * 0.4),
          window.innerHeight + 10,
          'duree');
      }
    }, 1000);
  }

  function arreterLive() {
    if (liveTimer) { clearInterval(liveTimer); liveTimer = null; }
    if (ecouteursPoses) {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('click', onClick);
      window.removeEventListener('scroll', onScroll);
      ecouteursPoses = false;
    }
    fx.detruire();
    // Le consentement est retiré : les compteurs repartent de zéro.
    live = { debut: Date.now(), souris: 0, clics: 0, scroll: 0 };
    DERNIER = { souris: 0, scroll: 0 };
  }

  /* ------------------------------------------------------------- Orchestration */

  function ouvrir(c) {
    if (started) { rendreConsentement(c); rendreGroupes(c); return; }
    started = true;

    gate.hidden = true;
    panel.hidden = false;

    rendreConsentement(c);
    demarrerLive();
    rendreGroupes(c);
  }

  function fermer(message) {
    started = false;
    arreterLive();
    panel.hidden = true;
    gate.hidden = false;
    if (gateNote && message) gateNote.textContent = message;
  }

  function evaluer() {
    var c = consentement();

    if (auMoinsUnAccord(c)) {
      ouvrir(c);
      return;
    }

    // Deux situations distinctes, deux messages distincts : ne pas avoir
    // répondu n'est pas la même chose qu'avoir refusé.
    if (aRepondu(c)) {
      fermer('Vous avez refusé toutes les finalités. Rien n’a été lu, et rien ne le sera : cette page s’arrête ici tant que vous ne changez pas d’avis.');
    } else if (started) {
      fermer('Vos choix ont été réinitialisés : plus rien n’est lu.');
    }
  }

  /* Bouton : rouvre la modale Axeptio.

     `openCookies()` est la méthode réellement exposée par le SDK chargé sur ce
     site — vérifiée sur l'objet window.axeptioSDK, et non déduite de la
     documentation. `openWidget` et `requestConsent` existent aussi et servent
     de secours ; le passage par _axcb couvre le cas où le SDK n'est pas encore
     prêt au moment du clic. */
  function ouvrirModaleAxeptio() {
    var sdk = window.axeptioSDK;
    if (sdk) {
      if (typeof sdk.openCookies === 'function')   { sdk.openCookies();   return true; }
      if (typeof sdk.openWidget === 'function')    { sdk.openWidget();    return true; }
      if (typeof sdk.requestConsent === 'function'){ sdk.requestConsent();return true; }
    }
    return false;
  }

  if (openBtn) {
    openBtn.addEventListener('click', function () {
      if (ouvrirModaleAxeptio()) return;

      // SDK pas encore chargé : on demande l'ouverture dès qu'il l'est.
      if (gateNote) gateNote.textContent = 'Ouverture du gestionnaire de consentement…';
      window._axcb = window._axcb || [];
      window._axcb.push(function () {
        if (!ouvrirModaleAxeptio() && gateNote) {
          gateNote.textContent = 'Le gestionnaire de consentement n’a pas pu s’ouvrir. Rechargez la page et réessayez.';
        } else if (gateNote) {
          gateNote.textContent = '';
        }
      });
    });
  }

  // Le SDK Axeptio prévient à chaque enregistrement de choix.
  window._axcb = window._axcb || [];
  window._axcb.push(function (sdk) {
    sdk.on('ready', evaluer);
    sdk.on('consent:saved', function () { setTimeout(evaluer, 60); });
  });

  // L'API de confidentialité Shopify émet aussi un événement.
  document.addEventListener('visitorConsentCollected', evaluer);

  // Filet : l'API Shopify peut arriver après nous. On la guette, sans s'acharner.
  var essais = 0;
  var attente = setInterval(function () {
    essais++;
    if (consentement() || essais > 40) {
      clearInterval(attente);
      evaluer();
    }
  }, 250);

  evaluer();
})();
